import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowLeft, Search } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <Helmet>
        <title>404 - Halaman Tidak Dijumpai | Flexa</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="text-center max-w-md">
        <p className="text-7xl font-extrabold text-violet-600 mb-4">404</p>
        <h1 className="text-2xl font-bold text-zinc-900 mb-2">Halaman Tidak Dijumpai</h1>
        <p className="text-zinc-500 mb-8">Maaf, halaman yang anda cari tidak wujud atau telah dialihkan.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="inline-flex items-center gap-2 h-10 px-5 rounded-full bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700">
            <ArrowLeft className="h-4 w-4" /> Halaman Utama
          </Link>
          <Link to="/services" className="inline-flex items-center gap-2 h-10 px-5 rounded-full border border-zinc-200 text-zinc-700 text-sm font-semibold hover:border-violet-300">
            <Search className="h-4 w-4" /> Lihat Servis
          </Link>
        </div>
        <div className="mt-10 pt-6 border-t border-zinc-100 flex flex-wrap justify-center gap-3">
          <Link to="/smm-panel-malaysia" className="text-xs text-violet-600 hover:underline">SMM Panel Malaysia</Link>
          <Link to="/blog" className="text-xs text-violet-600 hover:underline">Blog</Link>
          <Link to="/faq" className="text-xs text-violet-600 hover:underline">FAQ</Link>
          <Link to="/signup" className="text-xs text-violet-600 hover:underline">Daftar</Link>
        </div>
      </div>
    </div>
  );
}
